export default "__VITE_ASSET__C_jfJJu4__"